import { render, staticRenderFns } from "./processVersion.vue?vue&type=template&id=55424d66&scoped=true&lang=pug"
import script from "./processVersion.vue?vue&type=script&lang=js"
export * from "./processVersion.vue?vue&type=script&lang=js"
import style1 from "./processVersion.vue?vue&type=style&index=1&id=55424d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55424d66",
  null
  
)

export default component.exports